import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';

// `eager` (A07): o título do manifesto aparece no ⌘K e no breadcrumb antes de a tela abrir.
registerModuleCatalog('product-debit-account', (locale) => import(`./locales/${locale}.po`), {
  eager: true,
});
export const loadProductDebitAccountMessages = () => ensureModuleMessages('product-debit-account');
